export const LocaleConfig = [
  {
    code: "en",
    name: "English",
    nativeName: "English",
  },
  {
    code: "vi",
    name: "Vietnamese",
    nativeName: "Tiếng Việt",
  },
  {
    code: "fr",
    name: "French",
    nativeName: "France'",
  },
  { code: "de", name: "German" },
  { code: "ja", name: "Japanese" },
  { code: "ru", name: "Russian" },
  { code: "zh", name: "Chinese" },
  { code: "es", name: "Spanish" },
];
